export const tr = {
    'add-creatives': 'Seçilen öğeleri ekle',
    'cancel-and-return': 'İptal'
};
